import { render, staticRenderFns } from "./FeedbackDashboard.vue?vue&type=template&id=c2488de8&scoped=true&"
import script from "./FeedbackDashboard.vue?vue&type=script&lang=js&"
export * from "./FeedbackDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackDashboard.vue?vue&type=style&index=0&id=c2488de8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2488de8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRating } from 'vuetify/lib/components/VRating';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRating,VRow})
